import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { Box, Tab, Tabs, useTheme } from '@mui/material'
import { CrudAction, usePageHeader } from 'utils/hooks'
import { tabsData, TTabs } from './utils/consts'
import * as sxStyles from './Data.styled'
import { usePermissions } from 'utils/hooks/usePermissions'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const Data = () => {
  const theme = useTheme()
  const location = useLocation()
  const { checkPermission } = usePermissions()
  const publicSettings = useSelector(
    (state: RootState) => state?.user?.settings || {}
  )

  usePageHeader({
    headerTitle: 'Data',
  })

  const filteredTabs = tabsData.filter((tab) => {
    if (tab.settings && Object.keys(publicSettings).length > 0) {
      const settingValue = publicSettings[tab.settings]
      if (settingValue !== true) {
        return false
      }
    }

    if (!tab.permission) return true
    return checkPermission(tab.permission, CrudAction.GET)
  })

  const currentIndex = Math.max(
    0,
    filteredTabs.findIndex((t) =>
      location.pathname.toLowerCase().startsWith(`/data/${t.label}`)
    )
  )

  return (
    <Box sx={{ height: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
      <Box sx={sxStyles.boxWrapperStyle}>
        <Tabs
          sx={sxStyles.tabsWrapperStyle}
          TabIndicatorProps={{ style: { height: 3 } }}
          value={currentIndex}
          onChange={() => {}}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          {filteredTabs.map((tab: TTabs, index: number) => (
            <Tab
              label={tab.label}
              key={tab.id}
              value={index}
              component={NavLink}
              to={`/data/${tab.label}`}
              sx={{
                ...sxStyles.tabStyle,
                mr: index !== filteredTabs.length - 1 ? '10px' : 0,
                '&.Mui-selected': {
                  backgroundColor: theme.palette.primary.main,
                  color: '#fff',
                  fontWeight: 600,
                },
                '&:hover': {
                  backgroundColor: theme.palette.primary.light,
                  color: '#fff',
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={sxStyles.outletBox}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default Data
